<template>
  <div class="w-100">
    <div
      v-if="
        isLogged &&
        !isClerk &&
        this.loginType !== ExternalWagerLoginTypes.DepositTicket &&
        this.loginType !== ExternalWagerLoginTypes.ClerkDepositTicket
      "
    >
      <alert-message
        class="mt-0"
        v-if="hasRiskOrWin && !hasBalance && !isNaN(totalRiskAmount)"
        warning
        withoutIcon
        :description="
          !this.activeFreeBet
            ? $t('BetSlip.Exceed Text', [currencySymbol + '' + availableBalance, currencySymbol + '' + totalRiskAmount])
            : $t('BetSlip.FreeBetBalanceExceed', [
                currencySymbol + '' + availableBalance,
                currencySymbol + '' + totalRiskAmount,
              ])
        "
      />
      <div class="d-none">
        betConfirmationStatus.loading: {{ betConfirmationStatus.loading }}
        <hr />
        (!hasBalance && this.activeFreeBet):
        {{ !hasBalance && this.activeFreeBet }}
        <hr />
        (totalBets === 0): {{ totalBets === 0 }}
        <hr />
        (disablePlaceBetButton):
        {{ disablePlaceBetButton }}
      </div>

      <div class="bet-action-buttons d-flex justify-content-center">
        <button
          type="submit"
          class="btn place-bet-btn btn-primary w-100 place-bet-button-3 special-place-bet-btn"
          @click="tryPlaceBet()"
          :disabled="
            betConfirmationStatus.loading ||
            (!hasBalance && this.activeFreeBet) ||
            totalBets === 0 ||
            disablePlaceBetButton ||
            mustDisableWithMoreThanTwoSelections
          "
          :class="{ 'btn-loading-anim': betConfirmationStatus.loading }"
          v-if="(selectedType !== '' && hasBalance) || (selectedType !== '' && this.activeFreeBet)"
        >
          <span v-if="!betConfirmationStatus.loading" class="place-bet-btn-context">{{ $t('BetSlip.Place Bet') }}</span>
          <i class="fa fa-spin fa-spinner" v-if="betConfirmationStatus.loading"></i>
        </button>
        <router-link
          class="btn place-bet-btn btn-primary w-100 place-bet-button-1"
          to="/deposit"
          v-if="!hasBalance && !this.activeFreeBet"
          >{{ $t('BetSlip.Deposit Now to') }}
        </router-link>
      </div>
    </div>
    <div v-else>
      <alert-message
        class="mt-0"
        v-if="
          hasRiskOrWin &&
          !hasBalance &&
          (this.loginType === ExternalWagerLoginTypes.DepositTicket ||
            this.loginType === ExternalWagerLoginTypes.ClerkDepositTicket ||
               this.loginType === ExternalWagerLoginTypes.MobileScanCode)
        "
        warning
        withoutIcon
        :description="
          !this.activeFreeBet
            ? $t('BetSlip.Exceed Text', [currencySymbol + '' + availableBalance, currencySymbol + '' + totalRiskAmount])
            : $t('BetSlip.FreeBetBalanceExceed', [
                currencySymbol + '' + availableBalance,
                currencySymbol + '' + totalRiskAmount,
              ])
        "
      />
      <div class="d-flex justify-content-center">
        <button
          class="btn place-bet-btn btn-primary w-100 place-bet-button-2 special-place-bet-btn"
          @click="tryPlaceBet()"
          :disabled="
            betConfirmationStatus.loading ||
            (!hasBalance &&
              (this.loginType === ExternalWagerLoginTypes.DepositTicket ||
                this.loginType === ExternalWagerLoginTypes.ClerkDepositTicket ||
                  this.loginType === ExternalWagerLoginTypes.MobileScanCode)) ||
            totalBets === 0 ||
            disablePlaceBetButton ||
            mustDisableWithMoreThanTwoSelections
          "
          :class="{ 'btn-loading-anim': betConfirmationStatus.loading }"
        >
          <span v-if="!betConfirmationStatus.loading">{{ $t('BetSlip.Place Bet') }}</span>
          <i class="fa fa-spin fa-spinner" v-if="betConfirmationStatus.loading"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import { ExternalWagerLoginTypes, LoginTypes } from '@/utils/enums';

export default {
  props: [
    'betOptionsResponse',
    'totalRiskAmount',
    'totalBets',
    'disablePlaceBetButton',
    'disableMinMaxValidity',
    'wagerType',
  ],
  data() {
    return {
      hasRiskOrWin: false,
      isBetable: false,
      ExternalWagerLoginTypes,
      LoginTypes,
    };
  },
  watch: {
    betOptionsResponse() {
      this.checkBalance();
    },
  },
  computed: {
    ...mapState({
      activeFreeBet: (state) => state.betSlip.activeFreeBet,
      selectedType: (state) => state.betSlip.selectedType,
      isLogged: (state) => state.player.isLogged,
      betConfirmationStatus: (state) => state.betSlip.betConfirmationStatus,
      loginType: (state) => state.player.loginType,
      balance: (state) => state.player.balance,
      validity: (state) => state.betSlip.validity,
      isClerk: (state) => state.player.isClerk,
      ticketBalance: (state) => state.depositTicketStore.balanceResponse.available_balance,
      selections: (state) => state.betSlip.newBetSlipSelection,
    }),
    ...mapState({
      betSlipBetCount: (state) => state.betSlip.betSlipBetCount,
      betOptionsStatus: (state) => state.betSlip.betOptionsStatus,
    }),
    ...mapGetters({
      currencySymbol: 'player/currencySymbol',
    }),
    isLimitsExceed() {
      return this.checkValidity();
    },
    hasBalance() {
      let totalRisk = isNaN(this.totalRiskAmount) ? 0 : parseFloat(this.totalRiskAmount);
      return this.availableBalance > 0 && totalRisk <= this.availableBalance;
    },
    availableBalance() {
      if (this.loginType === LoginTypes.Player) {
        if (!this.activeFreeBet) {
          return this.balance.available ? parseFloat(this.balance.available.replace(/[^0-9.]/gi, '')) : 0;
        } else {
          return this.balance.free_play ? parseFloat(this.balance.free_play.replace(/[^0-9.]/gi, '')) : 0;
        }
      }
      if (
        this.loginType === ExternalWagerLoginTypes.DepositTicket ||
        this.loginType === ExternalWagerLoginTypes.ClerkDepositTicket ||
        this.loginType === ExternalWagerLoginTypes.MobileScanCode
      ) {
        return this.ticketBalance ? parseFloat(this.ticketBalance) : 0;
      }
      return 0;
    },
    mustDisableWithMoreThanTwoSelections() {
      //if is kiosk and selections.size >= 2 disable button in straight just in case
      if (this.selections && this.selections.size >= 2 && this.$isElectron && this.selectedType === 'straight') {
        return true;
      }
    },
  },
  methods: {
    ...mapActions({
      getBetConfirmations: 'betSlip/getBetConfirmations',
      getNewBetConfirmations: 'betSlip/getNewBetConfirmations',
      fillConfirmationData: 'betSlip/fillConfirmationData',
      placeBet: 'betSlip/placeBet',
    }),
    ...mapMutations({
      setShowLoginNeedModal: 'betSlip/setShowLoginNeedModal',
      setBetConfirmationResponse: 'betSlip/setBetConfirmationResponse',
    }),
    ...mapMutations('betSlip', ['setValidity']),
    canConfirmBet() {
      return (
        this.loginType === LoginTypes.Player ||
        this.loginType === LoginTypes.Clerk ||
        this.loginType === ExternalWagerLoginTypes.DepositTicket ||
        this.loginType === ExternalWagerLoginTypes.ClerkDepositTicket ||
        this.loginType === ExternalWagerLoginTypes.MobileScanCode
      );
    },
    checkValidity() {
      if (this.selectedType === 'round_robin') {
        return true;
      }
      let valid = true;
      let validationBets = [];
      if (this.selectedType == 'straight') {
        validationBets = this.betOptionsResponse.Selections.filter(
          (item) => !!parseInt(item.input_risk_amount) && !!parseInt(item.input_risk_amount),
        );
      } else {
        if (
          !!parseInt(this.betOptionsResponse.input_risk_amount) &&
          !!parseInt(this.betOptionsResponse.input_risk_amount)
        )
          validationBets = this.betOptionsResponse.Selections;
      }

      if (!validationBets.length) return (valid = false);
      validationBets.forEach((bet) => {
        let options = this.betOptionsResponse;
        let betCheck = bet;
        if (this.selectedType != 'straight') betCheck = this.betOptionsResponse;
        const risk = parseFloat(betCheck.input_risk_amount);
        const win = parseFloat(betCheck.input_win_amount || '0');
        if (isNaN(risk) || isNaN(win)) valid = false;
        this.hasRiskOrWin = !(isNaN(risk) || isNaN(win));
        if (!options.limits) valid = false;
        else if (
          options.limits.limit_type === 0 &&
          (risk < options.limits.min_bet ||
            risk > options.limits.max_bet ||
            win - risk < options.limits.min_bet ||
            win - risk > options.limits.max_bet)
        )
          valid = false;
        else if (options.limits.limit_type === 2 && risk < (options.limits.min_bet || risk > options.limits.max_bet))
          valid = false;
        else if (
          options.limits.limit_type === 1 &&
          (win - risk < options.limits.min_bet || win - risk > options.limits.max_bet)
        )
          valid = false;
        //else if (bet.bet.type == 'teaser' && win - risk < bet.options.limits.min_bet) valid = false;
        else if (this.selectedType == 'parlay' && options.Selections.length <= 1 && options.open_spots == 0)
          valid = false;
      });
      return valid;
    },
    checkBalance: function () {
      if (
        this.loginType === LoginTypes.Player ||
        this.loginType === ExternalWagerLoginTypes.DepositTicket ||
        this.loginType === ExternalWagerLoginTypes.ClerkDepositTicket ||
        this.loginType === ExternalWagerLoginTypes.MobileScanCode
      ) {
        if (this.betOptionsResponse.Selections) {
          this.betOptionsResponse.Selections.forEach((bet) => {
            const risk = parseFloat(bet.input_risk_amount);
            const win = parseFloat(bet.input_win_amount || '0');
            this.hasRiskOrWin = !(isNaN(risk) || isNaN(win));
          });
          this.isBetable = parseFloat(this.totalRiskAmount) <= this.availableBalance;
        } else {
          this.betOptionsResponse[0].Selections.forEach((bet) => {
            const risk = parseFloat(bet.input_risk_amount);
            const win = parseFloat(bet.input_win_amount || '0');
            this.hasRiskOrWin = !(isNaN(risk) || isNaN(win));
          });
          this.isBetable = parseFloat(this.totalRiskAmount) <= this.availableBalance;
        }

        return this.isBetable;
      }
      return true;
    },
    tryPlaceBet() {
      const vali = this.checkValidity();
      const betOptions = this.betOptionsResponse;
      betOptions.WagerType = this.wagerType;

      this.fillConfirmationData();
      this.setBetConfirmationResponse(betOptions);

      this.setValidity(vali);
      this.$emit('clicked');

      if (!this.checkBalance()) return;
      vali ? (this.canConfirmBet() ? this.placeBet() : this.setShowLoginNeedModal(true)) : this.$isElectron ? this.placeBet() : {};
    },
  },
};
</script>
<style lang="scss">
.alert {
  &-balance {
    overflow: hidden;

    .fa-exclamation-triangle {
      position: absolute;
      left: -10px;
      top: -14px;
      opacity: 0.1;
      font-size: 60px;
    }
  }
}

.special-place-bet-btn {
  height: 36px !important;
  line-height: 16px !important;
}

.place-bet-btn-context {
  font-size: 15px !important;
  font-weight: 600;
}
</style>
